module.exports = __webpack_public_path__ + "img/NavauthBg.8aeea552.png";